// eslint-disable-next-line
import React from "react";
import "../styles/Footer.css";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        {/* Logo Section */}
        <div className="footer-logo-section">
          <img src="/logo.jpg" alt="Company Logo" className="footer-logo" />

          <p>4151 Kessler Blvd E Dr, Indianapolis, IN 46220</p>
          <p>401 S Hamilton St, Gary, IN 46403</p>
          {/* <p>Phone: <a href="tel:1-888-862-9190">1-888-862-9190</a></p> */}
        </div>

        {/* Info Columns */}
        <div className="footer-columns">
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li>
                <a href="/">Home</a>
              </li>
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/capability">Statements</a>
              </li>
              <li>
                <a href="/gallery">Gallery</a>
              </li>
              <li>
                <a href="/contact">Contact</a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Projects</h4>
            <ul>
              <li><a href="/portfolio">Commercial</a></li>
              <li><a href="/portfolio">Residential</a></li>
              <li><a href="/portfolio">Entertainment</a></li>
              <li><a href="/portfolio">Government</a></li>
              <li><a href="/portfolio">School</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4><a href="/">Services</a></h4>
            <ul>
              <li><a href="/">Design-Build</a></li>
              <li><a href="/">General Contracting</a></li>
              <li><a href="/">Pre-Construction</a></li>
              <li><a href="/">Project Management</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul>
              <li>News</li>
              <li>Plan Room</li>
              <li>Join Our Team</li>
              <li>Privacy Policy</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} TMC Contractors. All rights
          reserved.
        </p>
        <p className="company-name">
          A Harvest Douglas Hospitality Company LLC
        </p>
        <div className="footer-social">
          <span>Follow Us </span>
          <div className="icons">
            <a href="/">
              <FaFacebookF />
            </a>
            <a href="/">
              <FaLinkedinIn />
            </a>
            <a href="/">
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
